export default __webpack_public_path__ + "static/media/009-guitar.a3af6185.svg";